$(document).ready(() => {
  const name = $(".email-js").first().text()
  const domain = $(".email-domain").first().text()
  $(".mailto").attr("href", "mailto: " + name + "@" + domain)
  $(".email-js").append('@');
})



// WEBPACK FOOTER //
// ./src/browser/oldJs/lib/email-js.js